import React from 'react'
import WizardIndex from "../Wizard/index"

function PdfView(props) {

    const urlParams = new URLSearchParams(new URL(window.location.href).search);
    const pdfViewerValue = urlParams.get('pdfViewer');

  return <WizardIndex {...props} match={{params:{bfile_id:pdfViewerValue}}}  isFromDirectUrl={true}  />

}

export default PdfView


// WEBPACK FOOTER //
// ./src/scenes/Wizard/pdfView.js